import _ from 'lodash';
import cx from 'classnames';

import styles from './palette.module.scss';
import { guid } from 'services/util';

import {
  CAROUSEL, CAROUSEL_CARD
} from 'constants/widgetTypes';

const generateCarouselData = (type) => {

  switch (type) {
    case 'basic':
      return {
        type: CAROUSEL,
        name: "Carousel",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "500px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 15,
              "offset": 10,
              "backgroundCornerRadius": 5,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                }
              }
            },
            "dots": {
              "flag": false,
              "style": "DEFAULT",
              "size": 10,
              "offset": 10,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "color",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "color",
                "r": 255,
                "g": 198,
                "b": 0,
                "a": 1
              }
            },
            "transition": {
              "autoPlay": false,
              "pauseOnHover": false,
              "visibleDuration": 1,
              "speed": 1,
              "style": "FADE"
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "300px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 16,
              "offset": 0,
              "backgroundCornerRadius": 0,
              "regular": {
                "color": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "solid",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                }
              },
              "hover": {
                "color": {
                  "type": "solid",
                  "r": 255,
                  "g": 198,
                  "b": 0,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                }
              }
            },
            "dots": {
              "flag": true,
              "style": "DEFAULT",
              "size": 6,
              "offset": 8,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "solid",
                "r": 255,
                "g": 198,
                "b": 0,
                "a": 1
              }
            },
            "transition": null
          }
        },
        content: null,
        widgets: [{
          type: CAROUSEL_CARD,
          name: "Slide",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 0,
                  "g": 0,
                  "b": 0,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "background": null
            }
          },
        },
        {
          type: CAROUSEL_CARD,
          name: "Slide",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 79,
                  "g": 78,
                  "b": 78,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "background": null
            }
          },
        },
        {
          type: CAROUSEL_CARD,
          name: "Slide",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 121,
                  "g": 124,
                  "b": 124,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "background": null
            }
          },
        }
        ]
      }

    case 'mordern':
      return {
        type: CAROUSEL,
        name: "Carousel",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "350px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 50,
              "offset": 10,
              "backgroundCornerRadius": 5,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              }
            },
            "dots": {
              "flag": false,
              "style": "DEFAULT",
              "size": 10,
              "offset": 10,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "color",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "color",
                "r": 34,
                "g": 171,
                "b": 200,
                "a": 1
              }
            },
            "transition": {
              "autoPlay": false,
              "pauseOnHover": false,
              "visibleDuration": 1,
              "speed": 1,
              "style": "FADE"
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "300px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 16,
              "offset": 0,
              "backgroundCornerRadius": 0,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              }
            },
            "dots": {
              "flag": true,
              "style": "DEFAULT",
              "size": 6,
              "offset": 8,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "solid",
                "r": 255,
                "g": 198,
                "b": 0,
                "a": 1
              }
            },
            "transition": null
          }
        },
        content: null,
        widgets: [{
          type: CAROUSEL_CARD,
          name: "Slide",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 234,
                  "g": 247,
                  "b": 249,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "background": null
            }
          },
        }
        ]
      }

    default:
      return {
        type: CAROUSEL,
        name: "Carousel",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "350px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 50,
              "offset": 10,
              "backgroundCornerRadius": 5,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              }
            },
            "dots": {
              "flag": false,
              "style": "DEFAULT",
              "size": 10,
              "offset": 10,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "color",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "color",
                "r": 34,
                "g": 171,
                "b": 200,
                "a": 1
              }
            },
            "transition": {
              "autoPlay": false,
              "pauseOnHover": false,
              "visibleDuration": 1,
              "speed": 1,
              "style": "FADE"
            }
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px",
                "rotate": "0deg"
              },
              "width": "100%",
              "height": "300px"
            },
            "stretched": false,
            "free": false,
            "arrows": {
              "enabled": true,
              "style": "MORDERN",
              "size": 16,
              "offset": 0,
              "backgroundCornerRadius": 0,
              "regular": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              },
              "hover": {
                "color": {
                  "type": "color",
                  "r": 34,
                  "g": 171,
                  "b": 200,
                  "a": 1
                },
                "backgroundColor": {
                  "type": "color",
                  "r": 255,
                  "g": 255,
                  "b": 255,
                  "a": 0
                }
              }
            },
            "dots": {
              "flag": true,
              "style": "DEFAULT",
              "size": 6,
              "offset": 8,
              "cornerRadius": 10,
              "defaultColor": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "selectedColor": {
                "type": "solid",
                "r": 255,
                "g": 198,
                "b": 0,
                "a": 1
              }
            },
            "transition": null
          }
        },
        widgets: [{
          type: CAROUSEL_CARD,
          name: "CarouselCard",
          properties: {
            "desktop": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": null
              },
              "background": {
                "type": "color",
                "color": {
                  "type": "solid",
                  "r": 234,
                  "g": 247,
                  "b": 249,
                  "a": 1
                },
                "media": null,
                "opacity": 0,
                "scale": null,
                "position": null
              }
            },
            "mobile": {
              "visible": true,
              "layout": {
                "transform": {
                  "translate": "0px, 0px"
                },
                "width": "100%",
                "height": "100%"
              },
              "background": null
            }
          },
        }]
      }
  }
}

export const carousels = [
  {
    id: 'basic_Carousel',
    name: 'Basic Carousel',
    render: () => {
      return <img className={cx(styles.menu, styles.basic)} src="/images/palette/carousel/basicCarousel.png" />
    },
    data: generateCarouselData('basic')
  },
  {
    id: 'standard_Carousel',
    name: 'Standard Carousel',
    render: () => {
      return <img className={cx(styles.menu, styles.basic)} src="/images/palette/carousel/mordernCarousel.png" />
    },
    data: generateCarouselData('mordern')
  }
]